/*
 * Copyright (c) 2019  Apricad LLC. All Rights Reserved.
 */

import { createSelector } from "reselect";

// --- for PDF Content ---
// ----------------------------------------------------------------------

// Function to retrieve piece of state
const dataContentLink = (state: any, props: any) => props.contentLink;
const dataPDFContent = (state: any) => state.state_infobox.pdfContent;

// Selector consumed by components consuming
export const selectorPDFContent = createSelector(
  [dataPDFContent],
  (pdfContent) => pdfContent,
);

// Selector consumed by action creator to check if the pdfContent is loaded
// Usage:  pdfContentLoaded(piece_of_state, props)   props indicates the data related in store
// Example: if (pdfContentLoaded(getState(), { contentLink: docpath }))
//
// [dataContentLink, dataPDFContent] are two functions that retrieve...
//  1. 'contentLink' from props, as requested_contentLink
//  2. pdfContent from state, as pdfContent
// In this case, we returns true/false only
export const pdfContentLoaded = createSelector(
  [dataContentLink, dataPDFContent],
  (requested_contentLink, pdfContent) =>
    pdfContent && pdfContent.contentLink === requested_contentLink,
);

// --- for Current (single) InfoBox ---
// ----------------------------------------------------------------------

// Function to retrieve piece of state
const dataInfoBoxId = (state: any, props: any) => props.ibx_id;
const dataCurrentInfoBox = (state: any) => state.state_infobox.currentInfoBox;

// Selector consumed by components consuming
export const selectorCurrentInfoBox = createSelector(
  [dataCurrentInfoBox],
  (currentInfoBox) => currentInfoBox,
);

// Selector consumed by action creator to check if the infobox is loaded
export const currentInfoBoxLoaded = createSelector(
  [dataInfoBoxId, dataCurrentInfoBox],
  (infoboxRequested_id, currentInfoBox) =>
    currentInfoBox && currentInfoBox._id === infoboxRequested_id,
);
